import { getComposeStore } from 'owa-calendar-compose-store-manager';
import { isFeatureEnabled } from 'owa-feature-flags';
import {
    getComposeHostItemIndex,
    lazyTriggerRecurrenceChangedEvent,
    lazyOnLaunchEventTriggered,
    AppointmentComposeAdapter,
    getAdapter,
    lazyConvertRecurrenceToAddinFormat,
    lazySeriesTimeJsonConverter,
} from 'owa-addins-core';
import { orchestrator } from 'satcheljs';
import { setRecurrence } from 'owa-calendar-compose-form-actions';
import { refreshTimeSuggestions } from 'owa-calendar-time-suggestions';
import refreshLocationSuggestions from '../utils/refreshLocationSuggestions';
import { prefetchRoomsAvailabilityForRoomPanel } from '../utils/prefetchRoomsAvailabilityForRoomPanel';
import fetchRecurrentEventResourcesAvailability from '../utils/fetchRecurrentEventResourcesAvailability';
import getFullComposeViewState from 'owa-calendar-compose-form-store/lib/selectors/getFullComposeViewState';
import { ExtensibilityModeEnum } from 'owa-addins-types';
import LaunchEventType from 'owa-service/src/contract/LaunchEventType';

export default orchestrator(setRecurrence, async actionMessage => {
    const store = getComposeStore();
    const calendarEvent = store.event;
    const originalEvent = store.originalEvent;
    const fullComposeViewState = getFullComposeViewState();

    const hostItemIndex = getComposeHostItemIndex(calendarEvent.ParentFolderId.Id);
    const adapter = getAdapter(hostItemIndex) as AppointmentComposeAdapter;
    if (adapter != null && adapter.mode === ExtensibilityModeEnum.AppointmentOrganizer) {
        const convertRecurrenceToAddinFormat = await lazyConvertRecurrenceToAddinFormat.import();
        const recurrence = convertRecurrenceToAddinFormat({
            recurrenceType: actionMessage.recurrenceType,
            startTime: adapter.getStartTime(),
            endTime: adapter.getEndTime(),
            timeZone: adapter.getTimeZone(),
        });

        lazyTriggerRecurrenceChangedEvent
            .import()
            .then(triggerRecurrenceChangedEvent =>
                triggerRecurrenceChangedEvent(hostItemIndex, recurrence)
            );

        if (
            isFeatureEnabled('addin-autoRun') &&
            isFeatureEnabled('addin-autoRun-appointmentRecurrenceChangedEvent')
        ) {
            const seriesTimeJsonConverter = await lazySeriesTimeJsonConverter.import();
            const formattedRecurrence = seriesTimeJsonConverter(recurrence);
            lazyOnLaunchEventTriggered.importAndExecute(
                hostItemIndex,
                LaunchEventType.OnAppointmentRecurrenceChanged,
                { type: 'olkRecurrenceChanged', ...{ recurrence: formattedRecurrence } }
            );
        }
    }

    if (
        isFeatureEnabled('cal-mf-availabilityForRecurrence') ||
        isFeatureEnabled('cal-mf-roomBookingPolicy')
    ) {
        refreshLocationSuggestions();
    }

    refreshTimeSuggestions(calendarEvent, false /* attendeesChanged */);

    // if in fullCompose prefetch room availabilities
    if (fullComposeViewState) {
        prefetchRoomsAvailabilityForRoomPanel(
            calendarEvent.Start,
            calendarEvent.End,
            calendarEvent.IsAllDayEvent,
            calendarEvent.Recurrence,
            calendarEvent.RequiredAttendees,
            calendarEvent.OptionalAttendees,
            originalEvent
        );
    }

    // Fetch availability for the resources of recurrent event. This is only for logging for experiment. We fetch the availabilities for all rooms in the Location well
    // using GetRoomAvailability, even when the flight 'cal-mf-availabilityForRecurrence' is off, to compare this availabilities between treatment and control.
    // TODO: Remove this when experiment is over (https://exp.microsoft.com/Rollout?id=f3d8a340-9076-46ee-8db1-d8e17e131b38)
    fetchRecurrentEventResourcesAvailability(calendarEvent);
});
